const urlName = '/usercenter/v1/user'

export default API => ({
  /**
   * 获取用户组织
   * @param { accountId: 账号Id }  param2
   * 响应数据data：  用户token，用于标识用户的登录状态信息。
   */
  getFindUserOrganByAccountId ({ params, data }) {
    return API({ url: `${urlName}/findUserOrganByAccountId`, params, data });
  },
  getFindByCondition({ params, data }) {
      return API({ url: `${urlName}/accountProfile/findByCondition`, params, data });
  },
  postSave({ params, data }) {
      return API({ url: `${urlName}/accountProfile/save`, method:'post', params, data });
  },
  postFindById({ params, data }){
      return API({ url: `${urlName}/accountProfile/findById`, method:'post', params, data });
  },
  postDelete({ params, data }){
      return API({ url: `${urlName}/accountProfile/delete`, method:'post', params, data });
  },
  getSaasFindByCondition(pageNum,pageSize,data) {
    console.debug(`${urlName}`);
    return API({
        url: `${urlName}/saas/findByCondition?pageSize=${pageSize}&pageNum=${pageNum}` ,
        method:  'get',
        data
    });
},

getUserOrganList(){
    return API({ url: `${urlName}/findUserOrganList`});
},

/**
  * 更新个人资料
  * @param {} 
  * 响应数据data：{}
  */
updateUser (params) {
    return API({ url: `/usercenter/v1/user/updateUser`, method: 'post', params });
  },
/**
  * 查询个人资料
  * 响应数据data：{}
  */
findUser () {
  return API({ url: `/usercenter/v1/user/findUser` });
},
})